// import React from 'react';

// export function ActivityDetailedChat() {
//     return (
//         <h1>Chat</h1>
//     )
// }

import { Field, FieldProps, Formik, Form } from 'formik';
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
//import {Segment, Header, Comment, Form, Button} from 'semantic-ui-react' //'o
import {Segment, Header, Comment, Button, Loader} from 'semantic-ui-react' //'n
import MyTextArea from '../../../app/common/form/MyTextArea';
import { useStore } from '../../../app/stores/store';
import * as Yup from'yup';
import { formatDistanceToNow } from 'date-fns';

interface Props { //'n
    activityId: string;
}

//export default observer(function ActivityDetailedChat() {
export default observer(function ActivityDetailedChat(props: Props) { //'n
    const {commentStore} = useStore(); //'n

    useEffect(() => {
        if (props.activityId) {
            commentStore.createHubConnection(props.activityId);
        }

        return () => {
            commentStore.clearComments();
        }
    }, [commentStore, props.activityId]);

    let masRequired = 'This feild is required!';
    const validationSchema = Yup.object({
        body: Yup.string().required(),
    });

    return (
        <>
            <Segment
                textAlign='center'
                attached='top'
                inverted
                color='teal'
                style={{border: 'none'}}
            >
                <Header>Chat about this event</Header>
            </Segment>
            <Segment attached clearing>
                <Comment.Group>
                    {/* <Comment>
                        <Comment.Avatar src='/assets/user.png'/>
                        <Comment.Content>
                            <Comment.Author as='a'>Matt</Comment.Author>
                            <Comment.Metadata>
                                <div>Today at 5:42PM</div>
                            </Comment.Metadata>
                            <Comment.Text>How artistic!</Comment.Text>
                            <Comment.Actions>
                                <Comment.Action>Reply</Comment.Action>
                            </Comment.Actions>
                        </Comment.Content>
                    </Comment>

                    <Comment>
                        <Comment.Avatar src='/assets/user.png'/>
                        <Comment.Content>
                            <Comment.Author as='a'>Joe Henderson</Comment.Author>
                            <Comment.Metadata>
                                <div>5 days ago</div>
                            </Comment.Metadata>
                            <Comment.Text>Dude, this is awesome. Thanks so much</Comment.Text>
                            <Comment.Actions>
                                <Comment.Action>Reply</Comment.Action>
                            </Comment.Actions>
                        </Comment.Content>
                    </Comment>

                    <Form reply>
                        <Form.TextArea>This is great! let me know, if you gonna join us.</Form.TextArea>
                        <Button
                            content='Add Reply'
                            labelPosition='left'
                            icon='edit'
                            primary
                        />
                    </Form> */}

                    
                    {/* <Form reply>
                        <Form.TextArea />
                        <Button content='Add Reply' labelPosition='left' icon='edit' primary />
                    </Form> */}

                    <Formik
                        onSubmit={(values, {resetForm}) => (
                            commentStore.addComment(values).then(() => (
                                resetForm()
                            ))
                        )}
                        initialValues={{body: ''}}
                        validationSchema={validationSchema}
                    >
                        {({isSubmitting, isValid, handleSubmit}) => (
                            <Form className='ui form' >
                                {/* <MyTextArea placeholder='Add comment' name='body' rows={3} />
                                <Button type='submit' content='Add Reply' labelPosition='left' icon='edit' primary loading={isSubmitting} disabled={isSubmitting || !isValid}  floated='right' /> */}
      
                                <Field name='body' >
                                    {(fieldProps: FieldProps) => (
                                        <div style={{position: 'relative'}}>
                                            <Loader active={isSubmitting} />
                                            <textarea 
                                                placeholder='Enter your comment (Enter to submit, SHIFT + Enter for new line)'
                                                rows={3}
                                                {...fieldProps.field}
                                                onKeyPress={event => {
                                                    if (event.key === 'Enter' && event.shiftKey) { //' >> new line
                                                        return; 
                                                    }

                                                    if (event.key === 'Enter' && !event.shiftKey) {
                                                        event.preventDefault(); // >> not to gave us a new line
                                                        isValid && (
                                                            handleSubmit()
                                                        );
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}
                                </Field>

                                {/* <div style={{paddingTop: '12px'}}>        
                                    <Button 
                                        type='submit' 
                                        content='Add Reply' 
                                        floated='right' 
                                        labelPosition='left' 
                                        icon='edit' 
                                        primary 
                                        loading={isSubmitting} disabled={isSubmitting || !isValid}  
                                    /> 
                                </div>   */}

                            </Form>
                        )}
                    </Formik>

                    {commentStore.chatCommentArray.map(comment => (
                        <Comment key={comment.id} >
                            <Comment.Avatar src={comment.photoUrl || '/assets/user.png'} />
                            <Comment.Content>
                                {/* <Comment.Author as='a'>Matt</Comment.Author> */}
                                <Comment.Author as={Link} to={`/profiles/${comment.userName}`}>{comment.displayName}</Comment.Author>
                                <Comment.Metadata>
                                    {/* <div>Today at 5:42PM</div> */}
                                    <div>{formatDistanceToNow(comment.createdDate)} ago</div>
                                </Comment.Metadata>

                                {/* <Comment.Text>{comment.body}</Comment.Text> */}
                                <Comment.Text style={{whiteSpace: 'pre-wrap'}} >{comment.body}</Comment.Text>

                                {/* <Comment.Actions>
                                    <Comment.Action>Reply</Comment.Action>
                                </Comment.Actions> */}
                            </Comment.Content>
                        </Comment>
                    ))}

                </Comment.Group>
            </Segment>
        </>

    )
})
